export const fetchMyDrafts = async (apiCall, cursor = null) => {
  try {
    const params = new URLSearchParams();
    if (cursor) params.append('cursor', cursor);

    const response = await apiCall(`/api/drafts/my-drafts?${params.toString()}`);
    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message || `HTTP error! status: ${response.status}`);
    }

    return {
      posts: data.posts || [],
      nextCursor: data.nextCursor || null,
      hasMore: data.hasMore || false
    };
  } catch (error) {
    throw error;
  }
};

export const fetchDraftById = async (apiCall, draftId) => {
  try {
    const response = await apiCall(`/api/drafts/${draftId}`);
    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message || `HTTP error! status: ${response.status}`);
    }

    return data.draft;
  } catch (error) {
    throw error;
  }
};

export const deleteDrafts = async (apiCall, draftIds) => {
  try {
    const response = await apiCall('/api/drafts/bulk-delete', {
      method: 'DELETE',
      body: JSON.stringify({ draftIds }),
    });

    const data = await response.json().catch(() => ({}));

    if (!response.ok || !data.success) {
      throw new Error(data.message || `Error: ${response.status}`);
    }

    return { success: true, deletedIds: data.deletedIds };
  } catch (error) {
    if (process.env.NODE_ENV !== 'production') {
      console.error('Delete drafts error:', error.message);
    }
    
    return {
      success: false,
      error: error.message || 'Failed to delete drafts. Please try again.'
    };
  }
};

export const updateDraft = async (draftId, postData, apiCall) => {
  try {
    const response = await apiCall(`/api/drafts/${draftId}`, {
      method: 'PATCH',
      body: JSON.stringify(postData),
    });

    const data = await response.json().catch(() => ({}));

    if (!response.ok || !data.success) {
      const errorMessage = data.errors?.[0]?.message || data.message || `Error: ${response.status}`;
      throw new Error(errorMessage);
    }

    return {
      success: true,
      data: data.data,
      post: data.data?.draft
    };
  } catch (error) {
    if (process.env.NODE_ENV !== 'production') {
      console.error('Update draft error:', error.message);
    }
    return {
      success: false,
      error: error.message || 'Failed to update draft. Please try again.'
    };
  }
};